<template>
  <div class="coupon-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.user_center') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.coupon') }}</span>
    </div>
    <div class="page-title">{{ $t('breadcrumbs.coupon') }}</div>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <user-side-menu page="coupon"/>
      </div>
      <div class="page-right ">
        <div class="page-right-title hide-on-pad">{{ $t('coupon.all_coupon') }}</div>
        
        <div class="coupon-type">
          <div class="type-item" :class="{ active: activeIndex==0}" @click="activeIndex=0">{{ $t('coupon.can_use') }} ({{ list.length>0?list[0].length:0 }})</div>
          <div class="type-item" :class="{ active: activeIndex==1}" @click="activeIndex=1">{{ $t('coupon.is_use') }} ({{ list.length>0?list[1].length:0 }})</div>
          <div class="type-item" :class="{ active: activeIndex==2}" @click="activeIndex=2">{{ $t('coupon.invalid') }} ({{ list.length>0?list[2].length:0 }})</div>
        </div>

        <div class="coupon-list">
          <div class="item" v-for="item in getActiveList" :key="item.id">
            <div class="item-content">
              <div class="icon">
                <img :src="item.photo">
                <p class="show-on-pad">{{ item.name }}</p>
              </div>
              <div class="content">
                <p class="show-on-pad number">{{ $t('coupon.coupon_num') }}: {{ item.no }}</p>
                <p class="title hide-on-pad">{{ item.name }}</p>
                <p class="hide-on-pad date">{{ $t('coupon.coupon_num') }}: {{ item.no }}</p>
                <p class="title show-on-pad-normal">{{ $t('coupon.rule') }}: {{ item.note }}</p>
                <p class="date">{{ $t('coupon.valid_date') }}: <span class="show-on-pad-normal">{{ moment(item.startDay).format("YYYY.MM.DD") }}{{ $t('coupon.date_dash') }}</span> {{ moment(item.endDay).format("YYYY.MM.DD") }}</p>
              </div>
              <div class="operate hide-on-pad">
                <div class="btn btn-orange use-coupon" @click="handleUseCoupon(item.id)">{{ $t('btns.use') }}</div>
                <div class="use-rule" @click="handleClickRules(item.note)">{{ $t('coupon.rule') }}</div>
              </div>
            </div>
          </div>
          <div class="no-data" v-show="getActiveList.length==0">
            {{ $t('coupon.no_coupon') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userSideMenu from '../../components/UserSideMenu'
// import Pagination from '../../components/Pagination/NewPagination.vue';
import { getDiscounts } from '../../api'
import moment from "moment";

import couponImg from './images/icon.png'
  export default {
    name: 'coupon',
    components: {
      userSideMenu
    },
    data() {
      return {
        couponImg,
        count: 1000,
        pages: 0,
        list: [],
        activeIndex: 0,
        // coupon: [
        //   {
        //     id: '1',
        //     img: couponImg,
        //     title: '9.5折 最低消費$3,000',
        //     date: '2020.06.05',
        //     number: '123214214'
        //   },{
        //     id: '2',
        //     img: couponImg,
        //     title: '9.5折 最低消費$3,000',
        //     date: '2020.06.05',
        //     number: '123214214'
        //   },
        //   {
        //     id: '3',
        //     img: couponImg,
        //     title: '9.5折 最低消費$3,000',
        //     date: '2020.06.05',
        //     number: '123214214'
        //   },
        //   {
        //     id: '4',
        //     img: couponImg,
        //     title: '9.5折 最低消費$3,000',
        //     date: '2020.06.05',
        //     number: '123214214'
        //   },
        //   {
        //     id: '5',
        //     img: couponImg,
        //     title: '9.5折 最低消費$3,000',
        //     date: '2020.06.05',
        //     number: '123214214'
        //   }
        // ]
      }
    },
    computed: {
      getActiveList() {
        if(this.list.length==0) return [];
        return this.list[this.activeIndex];
      }
    },
    created() {
      this.getList();
    },
    methods: {
      moment,
      handleUseCoupon(id) {
        console.log('id',id);
      },
      async getList() {
        this.pages++;
        const { pages, count } = this;
        const res = await getDiscounts({ pages,count });
        console.log(res.discounts);
        const canUse = res.discounts.filter(item => item.use_status==1 );
        const used = res.discounts.filter(item => item.use_status==2 );
        const invalid = res.discounts.filter(item => item.use_status==3 );
        this.list = [ canUse, used, invalid ];
      },
      handleClickRules(note) {
        // let routeData = this.$router.resolve({ name: 'CouponRules' });
        // window.open(routeData.href, '_blank');
        this.$alert(note, this.$t('coupon.rule'), {
          confirmButtonText: this.$t('btns.confirm'),
        });
      }
    }
  }
</script>

<style lang="less" scoped>
.coupon-page {
  @media (max-width: 992px) {
    background: #F7F8FA;
  }
  .page-right {
    min-height: 600px;
  }
  .page-right-title {
    background: #F0F0F0;
    padding: 10px;
    text-align: center;
    margin-bottom: 12px;
  }
  .coupon-type {
    margin-bottom: 30px;
    .type-item {
      display: inline-block;
      margin-right: 24px;
      cursor: pointer;
      &:nth-last-child(1) {
        margin-right: 0;
      }
      &.active {
        color: #EC4F00;
      }
    }
    @media (max-width: 992px) {
      display: flex;
      border-bottom: 2px solid #E6E6E6;
      margin-right: -16px;
      margin-left: -16px;
      justify-content: space-around;
      .type-item {
        // flex: 1;
        text-align: center;
        padding-bottom: 10px;
        margin-right: 0;
        position: relative;
        &.active {
          &:after {
            content: '';
            position: absolute;
            width: 100%;
            height: 4px;
            bottom: 0;
            left: 0;
            background: #EC4F00;
          }
        }
      }
    }
  }
  .coupon-list {
    display: flex; 
    flex-wrap: wrap;
  }
 
  .item {
    flex: 0 0 calc(50% - 8px);
    position: relative;
    padding-top: calc((50% - 8px)/404*91);
    margin-right: 16px;
    margin-bottom: 16px;
    // border: 4px solid #EC4F00;
    background-image: url('./images/bg.png');
    background-size: 100%;
    &:nth-child(2n) {
      margin-right: 0;
    }
    @media (max-width: 992px) {
      flex: 0 0 100%;
      padding-top: calc(100%/336*103);
      background-image: url('./images/bg_mobile.png');
      background-size: 100%;
    }
    .item-content {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    .icon {
      flex: 0 0 26%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-left: 16px;
      img {
        width: 54px;
        display: block;
      }
      p {
        margin-top: 6px;
        color: #888;
      }
      @media (max-width: 992px) {
        flex: 0 0 35%;
        padding-left: 5%;
        text-align: center;
      }
      @media (max-width: 400px) {
        img {
          width: 45px;
          display: block;
        }
      }
      @media (max-width: 350px) {
        img {
          width: 35px;
          display: block;
        }
        p {
          transform: scale(.9);
        }
      }
    }
    .content {
      height: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 10px;
      @media (max-width: 992px) {
        height: 80%;
        border-left: 1px dashed #707070;
        padding-left: 4%;
        padding-right: 5%;
      }
      .number {
        margin-bottom: 6px;
        @media (max-width: 992px) {
          color: black;
        }
      }
      .title {
        color: #EC4F00;
        font-weight: 400;
        font-size: 1.1rem;
        margin-bottom: 10px;
        @media (max-width: 992px) {
          margin-bottom: 6px;
          color: #000;
          font-weight: 200;
          font-size: 1rem;
        }
      }
      .date {
        font-size: 0.5rem;
        @media (max-width: 992px) {
          color: black;
        }
      }
    }
    .operate {
      padding-right: 25px;
      .use-coupon {
        border-radius: 20px;
        padding:4px 8px;
        font-size: 0.8rem;
        margin-bottom: 5px;
      }
      .use-rule {
        cursor: pointer;
        font-size: 0.8rem;
        text-align: center;
        color: #0084F7;
        text-decoration: underline;
      }
    }
  }
}
</style>